import { Query } from '@tanstack/react-query';

export function predicateType(query: Query, type: string) {
	return query.queryKey[0] === type;
}
